export enum IssueStatusEnum {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  REVIEWED = "REVIEWED",
  RESOLVED = "RESOLVED",
}

export function getIssueStatusLabel(status: IssueStatusEnum): string {
  const labels: Record<IssueStatusEnum, string> = {
    [IssueStatusEnum.DRAFT]: "Borrador",
    [IssueStatusEnum.PENDING]: "Pendiente",
    [IssueStatusEnum.REVIEWED]: "Revisada",
    [IssueStatusEnum.RESOLVED]: "Resuelta",
  };
  return labels[status] || status;
}

export const getIssueStatusOptions = (): { label: string; value: string }[] => {
  const keys = Object.keys(IssueStatusEnum).filter(
    (key: string) => typeof IssueStatusEnum[key as keyof typeof IssueStatusEnum] === "string"
  );
  return keys.map((val) => {
    const value = IssueStatusEnum[val as keyof typeof IssueStatusEnum];
    return { label: getIssueStatusLabel(value), value: value };
  });
};
